//"regionId":"regionId", 
//"nombre":"nombre", 
//"estatusId":"estatusId", 
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CiudadForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, regionCombo,paisCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Ciudad"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            
                            <Form.Field  required  error={errors.paisId}>
                              <label  >{strings?strings["paisId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["paisId"]:""} 
                                    name="paisId"
									fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.paisId}
                                    options={paisCombo}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.regionId}>
                              <label  >{strings?strings["regionId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["regionId"]:""} 
                                    name="regionId"
									fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.regionId}
                                    options={regionCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.nombre}>            
                              <label  >{strings?strings["nombre"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombre"]:""} 
                                    name="nombre"
                                    onChange={onChange}
                                    value={datos.nombre}
                                    icon='edit'/>
                            </Form.Field>
                                            
                           
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/ciudads">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CiudadForm;